<template>
  <responsive-drawer-header :hasDrawer="false" :moduleUnreadCount="unreadCount" :color="theme.appBar.other.color">
    <!-- left container -->
    <template v-slot:left-module-title>{{ mx_moduleTitle }}</template>
    <template v-slot:left-subtitle>
      {{ newsTitle }}
    </template>
    <template v-slot:right>
      <!-- label filters-->
      <label-group
        v-if="$route.name === 'news' && !displaySideNavigation && allLabels.length > 0"
        class="ml-6 touch"
        v-model="selectedLabelId"
        display-property="label"
        :labels="allLabels"
      ></label-group>

      <div v-if="!$route.params.itemId && !displaySideNavigation">
        <unread-filter class="d-flex px-2" v-if="!xs" />
      </div>
    </template>
  </responsive-drawer-header>
</template>

<script>
import { mapState } from 'vuex';
import common from '@/mixins/common';
import configMixin from '@/mixins/configMixin';
import UnreadFilter from './components/UnreadFilter.vue';
import navigationMixin from '@/mixins/navigationMixin';
import module from './index.js';
import ResponsiveDrawerHeader from '@/layouts/ResponsiveDrawerHeader.vue';
import LabelGroup from '@/components/groups/LabelGroup';

export default {
  mixins: [common, configMixin, navigationMixin],
  components: { ResponsiveDrawerHeader, /*Labels,*/ LabelGroup, UnreadFilter },

  created() {
    this.moduleType = module.moduleType;
  },
  mounted() {
    console.debug('mounted NewsHeader');
    this.$store.commit('news/setSelectedLabelId', null);
  },

  methods: {
    /** Back to news base view */
    back() {
      this.$router.push({ name: 'news', params: { instance: this.instance } });
    },
  },

  computed: {
    ...mapState('news', ['labelsById', 'labels', 'newsById', 'usedLabels']),
    instance() {
      return Number(this.$route.params.instance);
    },
    unreadCount() {
      return this.$store.getters[`news/getUnreadCountByModuleInstance`](this.instance);
    },

    allLabels() {
      return this.usedLabels.filter((label) => label.instance === this.instance);
    },
    displaySideNavigation() {
      const config = this.getModuleConfig(module.moduleType, this.instance);
      return config.hasSideNavigation && !this.smAndDown;
    },
    selectedLabelId: {
      get() {
        return this.$store.state.news.selectedLabelId;
      },
      set(value) {
        console.debug('selectedLabelId', value);
        this.showUnreadOnly = false;
        this.$store.commit('news/setSelectedLabelId', value);
      },
    },
    newsTitle() {
      if (this.$route.name === 'news') {
        return this.$t('news.subtitle');
      }
      if (this.newsById && this.newsById[this.$route.params.itemId]) {
        return this.newsById[this.$route.params.itemId].title;
      }
      return '';
    },
  },
};
</script>
